import { Injectable } from "@angular/core";
import { URLS } from '../../../config/api.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { map } from 'rxjs/operators';
import { CommonService } from "../../helpers/common.service";
import { environment } from "../../../environments/environment";
import { StorageServiceAAA } from "../../helpers/aaa-storage.service";


@Injectable()
export class TotalClientService {

    private clientDetailList = URLS.clientDetailList;
	private rmProfile = URLS.rmProfile;
	private fetchClientDashboardDetails = URLS.fetchClientDashboardDetails;

	public options:any;
	private gatewaySubscriptionKey:any;
	private nativeHeaders = environment['nativeHeaders'];
	env: any;

	constructor(private httpClient: HttpClient,
		private nativeHttp: HTTP,
		private commonService: CommonService,private storage: StorageServiceAAA) {
			this.storage.get('envSettings').then(res=>{
				this.gatewaySubscriptionKey = res.gatewaySubscriptionKey
				this.env = res.env
				this.options = this.env['headersParams-optionalHeaders']
			})
	}

	public clientList(cookievalue: any, data: any): Observable<{}> {
		let params: any = {
			head: {
				RequestCode: "CVUpdateLead01",
				Key: this.env.verifyGuestandExtendedApi.key,
				AppName: this.clientDetailList.appName,
				AppVer: "1.0.4.0",
				OsName: "Android",
			}
        }
        params['body']= data;
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.aaa,
			'appID': localStorage.getItem('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('json');
		return this.commonService.isApp() ? from(this.nativeHttp.post(this.clientDetailList.url, params, Object.assign(obj, this.nativeHeaders, this.options))).pipe(map(response => {
			return JSON.parse(response['data'] as any);
		})) : this.httpClient.post(this.clientDetailList.url, params, { headers: new HttpHeaders(obj) });
    }

	public fetchClientDetails(cookievalue: any, data: any, env:any): Observable<{}> {
		if(this.env == undefined || this.env == null){
            this.env = env
        }
		let params: any = {
			head: {
				RequestCode: "FetchClientDashBoardDetails",
				Key: this.env.verifyRequestApi.key,
				AppName: this.fetchClientDashboardDetails.appName,
				AppVer: "1.0.4.0",
				OsName: "Android",
				userType: localStorage.getItem('userType')
			}
        }
        params['body']= data;
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.aaa,
			'appID': localStorage.getItem('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('json');
		return this.commonService.isApp() ? from(this.nativeHttp.post(this.fetchClientDashboardDetails.url, params, Object.assign(obj, this.nativeHeaders, this.options))).pipe(map(response => {
			return JSON.parse(response['data'] as any);
		})) : this.httpClient.post(this.fetchClientDashboardDetails.url, params, { headers: new HttpHeaders(obj) });
    }

}